
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { services } from '../../../mocks/en/common';

export default function Services() {
  const [hoveredService, setHoveredService] = useState<number | null>(null);
  const navigate = useNavigate();

  const handleServiceClick = (serviceId: number) => {
    // Navigate to services page or show modal
    console.log('Service clicked:', serviceId);
  };

  const handleViewAllServices = () => {
    navigate('/services');
  };

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Our Professional Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            From complete renovations to specialized finishing work, we deliver exceptional results with Swiss precision and attention to detail.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="group bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer"
              onMouseEnter={() => setHoveredService(service.id)}
              onMouseLeave={() => setHoveredService(null)}
              onClick={() => handleServiceClick(service.id)}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/30 transition-colors duration-300" />
                <div className="absolute top-4 left-4">
                  <div className="w-12 h-12 bg-white/90 rounded-lg flex items-center justify-center">
                    <i className={`${service.icon} text-xl text-blue-600`}></i>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors duration-300">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
                
                <div className="mt-4 flex items-center text-blue-600 font-medium">
                  <span className="text-sm">Learn more</span>
                  <i className={`ri-arrow-right-line ml-2 transition-transform duration-300 ${
                    hoveredService === service.id ? 'translate-x-1' : ''
                  }`}></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={handleViewAllServices}
            className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            View All Services
          </button>
        </div>
      </div>
    </section>
  );
}
